module.exports = __webpack_public_path__ + "dscout-logo.png";